$(document).ready(function () {
  $(document).on("click", ".template-collection .popup-button, .template-collection .popup-button-a", function () {
    window.location.href = "https://karimdesign.dk/pages/booking";
    return false;
  });
  $('#PageContainer').on('change', '.variant-input-wrap input', function (event) {
    let value = event.target.value;
    if (value.includes('Tilpas størrelse')) {
      $('.measurements-div').css('display', 'flex');
    } else {
      $('.measurements-div').css('display', 'none');
    }
  });

  // Horizontal Filter Dropdown Toggle
  $(document).on('click', '.horizontal-filter-dropdown__trigger', function (e) {
    e.stopPropagation();
    var $trigger = $(this);
    var $dropdown = $trigger.siblings('.horizontal-filter-dropdown__content');
    var isOpen = $dropdown.is(':visible');

    // Close all other dropdowns first
    $('.horizontal-filter-dropdown__content').hide();
    $('.horizontal-filter-dropdown__trigger').removeClass('is-open').attr('aria-expanded', 'false');

    // Toggle current dropdown
    if (!isOpen) {
      $dropdown.show();
      $trigger.addClass('is-open').attr('aria-expanded', 'true');
    }
  });

  // Close dropdowns when clicking outside
  $(document).on('click', function (e) {
    if (!$(e.target).closest('.horizontal-filter-dropdown').length) {
      $('.horizontal-filter-dropdown__content').hide();
      $('.horizontal-filter-dropdown__trigger').removeClass('is-open').attr('aria-expanded', 'false');
    }
  });

  // Handle filter checkbox change - submit filter form
  $(document).on('change', '.horizontal-filter-dropdown__checkbox', function () {
    var $form = $(this).closest('form.filter-form');
    var params = new URLSearchParams(window.location.search);
    var name = $(this).attr('name');
    var value = $(this).val();

    if ($(this).is(':checked')) {
      params.append(name, value);
    } else {
      // Remove this specific value
      var values = params.getAll(name);
      params.delete(name);
      values.forEach(function (v) {
        if (v !== value) {
          params.append(name, v);
        }
      });
    }

    window.location.search = params.toString();
  });
});
